import React from 'react';
import { useSelector } from 'react-redux';

import { Form, DatePicker, Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import { formatDate } from 'utilities/common';

const initialState = {
  ref_code: '',
  customer: null,
  selectedRecipient: null,
  recipient: {
    id: '',
    name: '',
    phone: '',
    address: '',
    region: null,
  },
  shipping_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  note: '',
};

export const FormInput = ({ data, loading, onInputChange }) => {
  const StateForm = useSelector((state) => state?.Form);

  const [{ ref_code, customer, recipient, shipping_at, note, selectedRecipient }, setState] =
    React.useState(initialState);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  React.useEffect(() => {
    const input = {
      ref_code,
      customer,
      recipient,
      shipping_at,
      note,
    };

    onInputChange(input);
  }, [ref_code, customer, recipient, shipping_at, note]);

  const $handleRecipientSelected = async (v) => {
    let recip = null;

    if (v) {
      recip =  {
        id: v?.id,
        name: v?.name,
        phone: v?.phone_number,
        address: v?.address,
        region: v?.region
      }
    }


    setState((prevState) => ({...prevState, selectedRecipient: v, recipient: recip}));
  }

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      ref_code: data?.ref_code,
      customer: data?.customer,
      recipient: {
        id: data?.recipient_location_id,
        name: data?.recipient_name,
        phone: data?.recipient_phone,
        address: data?.recipient_address,
        region: data?.recipient_region,
      },
      shipping_at: {
        default: new Date(data?.shipping_date),
        formatted: formatDate(data?.shipping_date, 'YYYY-MM-DD'),
      },
      note: data?.note
    }));
  }, [data])

  return (
    <div className="mt-3 border-end">
      <div className="fw-semibold ps-2 ps-0 py-2 fs-6">Data Penerima</div>
      <div className="py-3 px-2 px-md-2 pe-md-4">
        {loading ? (
          <div className="row ">
            {dummy?.map((d, i) => (
              <div className="col-md-4" key={i}>
                <SkeletonsForm count={1} />
              </div>
            ))}
          </div>
        ) : (
          <>
            <Form.Input
              label="Customer Reference Number"
              type="text"
              value={ref_code}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  ref_code: e.target.value,
                }))
              }
              error={StateForm?.errors?.ref_code}
            />
            <div className="mb-3">
              <Select.Remote
                required
                label="Pilih Customer"
                placeholder=""
                url="/partner"
                params={{type: 'customer'}}
                value={customer}
                initialValue={customer?.id}
                row={(d) => {
                  return {
                    value: d.id,
                    label: d?.company_name
                      ? `${d.name} - ${d.company_name}`
                      : `${d.name}`,
                  };
                }}
                keys={customer?.id}
                onSelected={(c) => {
                  setState((prevState) => ({
                    ...prevState,
                    customer: c
                  }));
                }}
                errors={StateForm?.errors?.customer_id}
              />
            </div>
            {
              customer &&
              <div className="mb-3">
                <Select.Remote
                  label="Pilih Penerima"
                  placeholder=""
                  url="/location"
                  value={selectedRecipient}
                  params={{
                    customer_id: customer?.id,
                  }}
                  initialValue={data?.recipient?.id || selectedRecipient?.id}
                  row={(d) => {
                    return {
                      value: d.id,
                      label: d.name,
                    };
                  }}
                  keys={customer?.id}
                  disabled={!customer}
                  onSelected={(c) => $handleRecipientSelected(c)}
                  errors={StateForm?.errors?.recipient_id}
                />
              </div>
            }
            <Form.Input
              required
              label="Nama Penerima"
              type="text"
              value={recipient?.name}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  recipient: {
                    ...prevState?.recipient,
                    name: e.target.value,
                  },
                }))
              }
              error={StateForm?.errors?.recipient_name}
            />

            <Form.Input
              required
              label="No. Handphone"
              type="text"
              value={recipient?.phone}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  recipient: {
                    ...prevState?.recipient,
                    phone: e.target.value,
                  },
                }))
              }
              error={StateForm?.errors?.recipient_phone}
            />

            <Form.Textbox
              required
              label="Alamat"
              type="text"
              value={recipient?.address}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  recipient: {
                    ...prevState?.recipient,
                    address: e.target.value,
                  },
                }))
              }
              error={StateForm?.errors?.recipient_address}
            />
            <div className="mb-3">
              <Select.Remote
                required
                label="Pilih Wilayah"
                placeholder=""
                url="/region"
                value={recipient?.region}
                initialValue={
                  recipient?.region?.village_id
                }
                params={{
                  search:
                    recipient?.region?.postal_code,
                }}
                row={(d) => {
                  return {
                    value: d.village_id,
                    label: `${d.village_name}, ${d.district_name}, ${d.regency_name}, ${d?.province_name} ${d.postal_code} `,
                  };
                }}
                keys={recipient?.region}
                onSelected={(c) => {
                  setState((prevState) => ({
                    ...prevState,
                    recipient: {
                      ...prevState?.recipient,
                      region: c,
                    },
                  }));
                }}
                errors={StateForm?.errors?.recipient_region_id}
                hint="cari berdasarkan kecamatan/kabupaten/kota/provinsi/kode pos. e.g: 44152"
              />
            </div>

            <div className="mb-3">
              <label className="form-label required">Jadwal Pengiriman</label>
              <div
                className={
                  StateForm?.errors?.shipping_at
                    ? 'border border-danger rounded'
                    : ''
                }
              >
                <DatePicker
                  type="normal"
                  value={shipping_at?.default || null}
                  format="dd/MM/yyyy"
                  onChange={(date) => {
                    setState((prevState) => ({
                      ...prevState,
                      shipping_at: {
                        default: date,
                        formatted: formatDate(date, 'YYYY-MM-DD'),
                      },
                    }));
                  }}
                  isShowTrigger
                />
              </div>
              {StateForm?.errors?.shipping_at && (
                <div
                  className="invalid-feedback"
                  style={{ display: 'block' }}
                >
                  {StateForm?.errors?.shipping_at}
                </div>
              )}
            </div>

            <Form.Textbox
              label="Catatan"
              value={note}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  note: e.target.value,
                }))
              }
              error={StateForm?.errors?.note}
            />
          </>
        )}
      </div>
    </div>
  );
};
